import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords,
  canonicalUrl,
  ogImage = 'https://primeedge-solutions.com/uploads/og-image.jpg',
  ogUrl,
  article = false
}) => {
  // Get the current URL if not provided
  const currentUrl = ogUrl || (typeof window !== 'undefined' ? window.location.href : '');
  const siteUrl = 'https://primeedge-solutions.com'; // Replace with your actual domain
  const fullCanonicalUrl = canonicalUrl ? `${siteUrl}${canonicalUrl}` : currentUrl;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      {title && <title>{title} | Prime Edge</title>}
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="robots" content="index, follow" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullCanonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={article ? 'article' : 'website'} />
      <meta property="og:site_name" content="Prime Edge" />
      <meta property="og:url" content={currentUrl} />
      {title && <meta property="og:title" content={`${title} | Prime Edge`} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@PrimeEdge" />
      {title && <meta name="twitter:title" content={`${title} | Prime Edge`} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />
      
      {/* Additional SEO tags */}
      <meta name="author" content="Mohamed Tarek Mohamed Rezk" />
      <meta name="language" content="English" />
    </Helmet>
  );
};

export default SEO;